var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCitrusLink2020(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.45 51.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "0.07 50.81 177.72 50.81 177.72 3.51 215.54 3.51",
    style: {
      fill: "none",
      stroke: "#808285",
      strokeMiterlimit: 10,
      strokeWidth: "0.786430339941122px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dot"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 216.15,
    cy: 3.55,
    r: 3.55,
    style: {
      fill: "#f8992d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "LogoType"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.05,122.83a19.91,19.91,0,0,1-7.27-1.28A18.31,18.31,0,0,1,36,118.07a16,16,0,0,1-3.84-5.22,15.07,15.07,0,0,1-1.39-6.42v-.1a15.08,15.08,0,0,1,1.37-6.4A16.26,16.26,0,0,1,36,94.69a18.28,18.28,0,0,1,5.86-3.55,20.56,20.56,0,0,1,7.47-1.3,25.65,25.65,0,0,1,4.48.36,20.23,20.23,0,0,1,3.71,1,18,18,0,0,1,3.13,1.57,24.36,24.36,0,0,1,2.71,2l-4,4.14a20.85,20.85,0,0,0-4.56-2.87A13.11,13.11,0,0,0,49.25,95a12.31,12.31,0,0,0-4.74.89,11.89,11.89,0,0,0-3.76,2.41,10.7,10.7,0,0,0-2.46,3.58,11.1,11.1,0,0,0-.87,4.37v.09a11.25,11.25,0,0,0,.87,4.4,10.91,10.91,0,0,0,2.46,3.63,11.6,11.6,0,0,0,3.76,2.43,12.31,12.31,0,0,0,4.74.89,13.12,13.12,0,0,0,5.63-1.11,22.22,22.22,0,0,0,4.66-3l4.05,3.65a22.77,22.77,0,0,1-2.9,2.35,19.5,19.5,0,0,1-3.25,1.77,16.94,16.94,0,0,1-3.81,1.14A24.83,24.83,0,0,1,49.05,122.83Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#f8992d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66,90.39h6.25v31.89H66.66Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#f8992d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,95.58H76.13V90.39h29.08v5.19H93.84v26.7H87.5Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#f8992d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,90.39h16a19.56,19.56,0,0,1,6,.84,12.23,12.23,0,0,1,4.35,2.35,9,9,0,0,1,3,6.88v.09a9.25,9.25,0,0,1-.64,3.53,8.94,8.94,0,0,1-1.76,2.78,10.46,10.46,0,0,1-2.69,2,14.09,14.09,0,0,1-3.46,1.3l9.68,12.07H131l-8.84-11.11h-7.91v11.11H108Zm15.49,15.81a9.06,9.06,0,0,0,5.39-1.44,4.59,4.59,0,0,0,2-3.92v-.09a4.51,4.51,0,0,0-1.95-4,9.56,9.56,0,0,0-5.49-1.35h-9.2V106.2Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#f8992d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,122.78a21,21,0,0,1-6.3-.88,13,13,0,0,1-4.81-2.67,11.65,11.65,0,0,1-3.07-4.4,15.83,15.83,0,0,1-1.08-6.08V90.39h6.25v18.13c0,3,.8,5.24,2.42,6.79a9.25,9.25,0,0,0,6.69,2.33,9.39,9.39,0,0,0,6.64-2.24c1.62-1.49,2.42-3.7,2.42-6.65V90.39h6.25v18.09a16.44,16.44,0,0,1-1.1,6.24,12.24,12.24,0,0,1-3.1,4.49,12.89,12.89,0,0,1-4.84,2.69A21.37,21.37,0,0,1,155.9,122.78Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#f8992d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.72,122.74a25.28,25.28,0,0,1-7.94-1.25,22.32,22.32,0,0,1-7-3.85l3.78-4a22.64,22.64,0,0,0,5.28,3.07,15.94,15.94,0,0,0,6,1.07,8.51,8.51,0,0,0,4.63-1.09,3.32,3.32,0,0,0,1.72-2.92v-.09a3.34,3.34,0,0,0-.33-1.52,3.51,3.51,0,0,0-1.24-1.26,10.28,10.28,0,0,0-2.46-1.09,36.43,36.43,0,0,0-4.08-1,45,45,0,0,1-5.11-1.35,14.55,14.55,0,0,1-3.75-1.82,7.22,7.22,0,0,1-2.31-2.62,8.1,8.1,0,0,1-.79-3.74v-.09a7.83,7.83,0,0,1,.91-3.76,8.77,8.77,0,0,1,2.52-2.91,12.1,12.1,0,0,1,3.84-1.9,17,17,0,0,1,4.91-.68,22.7,22.7,0,0,1,7.1,1,21.76,21.76,0,0,1,5.91,3L197,98.18a23,23,0,0,0-4.86-2.44,14.72,14.72,0,0,0-4.87-.84,7.31,7.31,0,0,0-4.3,1.09,3.23,3.23,0,0,0-1.53,2.69v.09a3.51,3.51,0,0,0,.35,1.62,3.34,3.34,0,0,0,1.31,1.27,12.28,12.28,0,0,0,2.62,1.08c1.11.33,2.52.68,4.24,1a44,44,0,0,1,5,1.42,12.69,12.69,0,0,1,3.62,1.89,7.63,7.63,0,0,1,2.18,2.59,7.54,7.54,0,0,1,.75,3.44v.1a8.56,8.56,0,0,1-.94,4,8.84,8.84,0,0,1-2.62,3,12,12,0,0,1-4,1.87A19.45,19.45,0,0,1,188.72,122.74Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#f8992d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.29,90.39H220v29.75h21v2.14h-23.7Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#808285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,90.39h2.66v31.89H245.5Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#808285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,90.39h2.5l24.73,27.75V90.39h2.56v31.89h-2L257.89,93.94v28.34h-2.56Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#808285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.93,90.39h2.67v21l22.83-21h3.64L305.4,104.47l16.33,17.81h-3.48l-14.74-16.13-8.91,8v8.11h-2.67Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#808285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77,90.77h-2v-.34h4.39v.34h-2V95.5h-.42Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#808285"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.85,90.43h.4l2.28,3,2.29-3h.4V95.5h-.43V91.09L330.54,94h0l-2.26-2.92V95.5h-.4Z",
    transform: "translate(-30.77 -79.37)",
    style: {
      fill: "#808285"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitrusLink2020);
export default __webpack_public_path__ + "static/media/CitrusLink-2020.2d4e08d323412d8ca045818255b297c8.svg";
export { ForwardRef as ReactComponent };